module.exports = __webpack_public_path__ + "img/2006.adfe025a.jpg";